<style scoped lang="scss">
.container1 {
  background: #fff;
  margin-top: 10px;
  margin-bottom: 60px;
  border-radius: 6px;
  padding: 0 20px 20px;
  min-height: calc(100vh - 230px);
}
.header {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #999999;
  justify-content: space-between;
  .back {
    padding-right: 10px;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-top: -3px;
    }
    &:hover span {
      color: $color-theme;
    }
  }
}

.main {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  .similar-area {
    flex: 1;
    .title {
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      margin-bottom: 10px;
      .title-more {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 20px;
        color: rgba(131, 140, 155, 1);
        opacity: 1;
      }
    }
  }
  .origin-area {
    width: 250px;
    padding: 35px 0 0 20px;
    .title {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
    }
    .questionIndexContainer {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      margin-top: 10px;
      .indexItem-container {
        flex: 0 0 20%;
        height: 28px;
        margin-bottom: 15px;
      }
      .indexItem {
        width: 28px;
        height: 28px;
        background: rgba(234, 239, 246, 1);
        border-radius: 50%;
        opacity: 1;
        color: rgba(151, 161, 178, 1);
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 28px;
        text-align: center;
        cursor: pointer;
        transition: all ease 0.2s;
        user-select: none;
      }
      .indexItem:hover {
        background: #478eff;
        color: #fff;
      }
      .active {
        background: #478eff;
        color: #fff;
      }
    }
  }
}
.fixed-area {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -10px 14px rgba(204, 204, 204, 0.16);
  border-radius: 4px;
}
</style>

<style lang="scss">
#editor iframe html body img {
  vertical-align: middle;
}
.origin-question {
  .content {
    img {
      vertical-align: middle;
    }
  }
  .question-content {
    img {
      vertical-align: middle;
    }
  }
  .options {
    margin-top: 10px;
  }
  .options-item {
    display: inline-block;
    min-width: 20%;
    margin-right: 4%;
    font-size: 14px;
    color: #333;
    * {
      display: inline-block;
    }
    img {
      vertical-align: middle;
    }
  }
}
.select-round {
  display: inline-block;
  .el-select__caret {
    color: #fff !important;
  }
  .el-select {
    width: 85px;
    .el-input {
      .el-input__inner {
        color: #fff;
        text-align: center;
        border-radius: 20px;
        border-color: $color-theme;
        background: $color-theme;
      }
    }
  }
}
</style>
<template>
  <div class="container1" v-loading="loading">
    <header class="header">
      <div class="back" @click="$router.back()">
        <img src="~images/back.png" width="10" />
        <span>返回</span>
      </div>
      <div>
        <el-button
          type="primary"
          size="small"
          style="padding-left:25px;padding-right:25px;"
          @click="_parsingHtml"
        >保存</el-button>
      </div>
    </header>

    <div class="main">
      <div class="similar-area">
        <div class="title">
          编辑类题内容
          <span class="title-more">
            (可编辑
            <span style="color:#478EFF">一道或多道</span>原题的类题)
          </span>
        </div>
        <div class="editor">
          <div id="editor"></div>
        </div>
      </div>
      <div class="origin-area">
        <div class="title">点击查看原题</div>
        <div class="questionIndexContainer">
          <div class="indexItem-container" v-for="(q,i) in questionList" :key="i">
            <div
              @click="handleQuestionClick(q,i)"
              class="indexItem"
              :class="{active:q.count> 0}"
            >{{q.num}}</div>
          </div>
          <div class="indexItem-container" style="height:0;margin-bottom:0"></div>
          <div class="indexItem-container" style="height:0;margin-bottom:0"></div>
          <div class="indexItem-container" style="height:0;margin-bottom:0"></div>
          <div class="indexItem-container" style="height:0;margin-bottom:0"></div>
        </div>
      </div>
    </div>

    <yue-dialog title="查看原题" :visible.sync="dialogFormVisible" width="800px">
      <div class="origin-question">
        <div class="content" style="line-height:20px">
          <div v-if="examInfo.hasPaper == 2">
            <div v-html="currentQuestion.info.content"></div>
            <div v-if="currentQuestion.options" class="options">
              <span
                class="options-item"
                v-html="optionLabels[index] + '. ' + opt.content"
                v-for="(opt,index) in currentQuestion.options"
              ></span>
            </div>
          </div>
          <div v-else class="no-content">
            <img src="~images/similar_nocontent.png" alt />
            <span>未上传试题，无法显示题目，可继续设置类题</span>
          </div>
        </div>
      </div>
    </yue-dialog>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import {
  getExamTeacherQuestion,
  getExamQuestionList,
  parsingHtml
} from "@/api/exam/report";
import { domain } from "@/config";
import { mapGetters } from "vuex";
// import VueCkeditor from "vue-ckeditor2";

export default {
  data() {
    return {
      loading: false,
      currentQuestion: {
        info: {}
      },
      examInfo: {},
      currentIndex: -1,
      questionList: [],
      quesBody: "",
      setSimilarVisible: false,
      dialogFormVisible: false,
      isImportType: 0,
      reportType: 0,
      showReport: false, // 是否展示报告
      schoolId: "",
      examId: "",
      examName: "",
      classId: "",
      studentId: "",
      className: "",
      gradeName: "",
      subjectName: "",
      studentName: "",
      optionLabels: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      //左侧栏
      postionClass: "",
      config: {
        toolbar: [
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Subscript",
              "Superscript",
              "RemoveFormat"
            ]
          },
          {
            name: "justify",
            items: [
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock"
            ]
          },
          {
            name: "insert",
            items: ["Nn", "SpecialChar", "Image", "Table", "kityformula"]
          },
          { name: "undo", items: ["Undo", "Redo"] }
        ],
        filebrowserImageUploadUrl:
          domain + "/marking-platform/ossUpload/upload_to?CKEditorFuncNum=1",
        removeDialogTabs: "image:advanced;image:Link",
        height: 300,
        extraPlugins: "kityformula"
      }
    };
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    })
  },
  created() {
    this.reportType = parseInt(this.$route.query.reportType);
    this.schoolId = this.userInfo.schoolId;
    this.examId = this.$route.params.examId;
    this.classId = this.$route.params.classId;
    this.className = this.$route.query.className;
  },

  mounted() {
    this._getExamQuestionList();
    this._initNavScroll();
    this.loading = true;
    let editor = CKEDITOR.replace("editor", {
      toolbarGroups: [
        { name: "clipboard", groups: ["undo"] },
        { name: "editing", groups: ["find", "selection"] },
        { name: "insert" },
        { name: "forms" },
        { name: "tools" },
        { name: "document", groups: ["mode", "document", "doctools"] },
        { name: "others" },
        { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
        {
          name: "paragraph",
          groups: ["list", "indent", "blocks", "align", "bidi"]
        },
        { name: "styles" },
        { name: "colors" },
        { name: "kityformula" }
      ],
      extraPlugins: "kityformula",
      skin: "moono-lisa",
      filebrowserImageUploadUrl:
        domain + "/marking-platform/ossUpload/upload_to?CKEditorFuncNum=1",
      height: document.body.clientHeight - 400
    });
    editor.on("change", function(evt) {
      try {
        console.log("change");
        let dom = document.getElementsByTagName("iframe")[0].contentWindow
          .document;
        let imgs = dom.querySelectorAll("img");
        imgs.forEach(function(item) {
          if (item.style.verticalAlign == "") {
            item.style.verticalAlign = "middle";
          }
        });
      } catch (error) {
        console.log(error);
      }
    });
    this._getExamTeacherQuestion();

    this.loading = false;
  },

  methods: {
    async _parsingHtml() {
      this.loading = true;
      let data = CKEDITOR.instances.editor.getData();
      let res = await parsingHtml({
        html: data,
        examId: this.examId
      });
      if (res.code == 200) {
        this.$message.success("保存成功");
        this._getExamTeacherQuestion();
      } else {
        this.$message.error(res.message);
      }
    },
    async _getExamTeacherQuestion() {
      let res = await getExamTeacherQuestion({
        examId: this.examId
      });
      if (res.code == 200) {
        this.serverQuestionList = res.result;
        this.formatToString();
      } else {
        this.$message.error(res.message);
      }
    },
    formatToString() {
      let list = this.serverQuestionList;
      let string = "";
      list.map(l => {
        string += "<p>【题号】<br>第" + l.standNum + "题</p>"; //题号
        if (l.questions.length > 0) {
          l.questions.map(q => {
            string += "<p>【题文】" + q.quesBody + "</p>"; //题文
            string += "<p>【答案】" + q.quesAnswer + "</p>"; //答案
            string += "<p>【解析】" + q.quesParse + "</p>"; //解析
            string += "<p>【题型】" + q.quesTypeName + "</p>"; //题型
            string += "<br>";
          });
        } else {
          string += "<p>【题文】<br>" + "</p>"; //题文
          string += "<p>【答案】<br>" + "</p>"; //答案
          string += "<p>【解析】<br>" + "</p>"; //解析
          string += "<p>【题型】<br>" + "</p>"; //题型
        }
        string += "<hr>";
      });
      this.loading = true;
      let time = setInterval(() => {
        if (CKEDITOR.instances.editor) {
          CKEDITOR.instances.editor.setData(string);
          clearInterval(time);
          this.loading = false;
        }
      }, 2000);
    },
    async _getExamQuestionList() {
      let res = await getExamQuestionList({
        examId: this.examId
      });
      if (res.code == 200) {
        this.examInfo = res.result.examBase;
        this.questionList = res.result.rows;
        this.subjectName = res.result.subjectName;
        this.gradeName = res.result.grade.gradeName;
      } else {
        this.$message.error(res.message);
      }
    },
    handleQuestionClick(item, index) {
      this.currentQuestion = item;
      this.currentIndex = index;
      this.dialogFormVisible = true;
    },
    handleSetSimilar() {
      this.setSimilarVisible = true;
    },

    _initNavScroll() {
      window.addEventListener("scroll", this._navScroll);
    },

    _navScroll() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.postionClass = scrollTop >= 218 ? "nav-fixed" : "";
    }
  },
  components: {
    // VueCkeditor
  }
};
</script>
